package com.patronat.top.features.auth.domain.usecase

import com.patronat.top.core.domain.usecase.command.auth.SendCodeToPhoneCommand
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.features.auth.data.mappers.toDomain
import com.patronat.top.features.auth.domain.models.AuthResult
import com.patronat.top.features.auth.domain.repository.AuthRepository

class ResendPhoneCodeUseCase(
    private val repository: AuthRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<SendCodeToPhoneCommand, DomainResult<AuthResult>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: SendCodeToPhoneCommand): DomainResult<AuthResult> {
        return repository.resendPhoneCode(command)
    }
}